module.exports = __webpack_public_path__ + "static/media/cleaning.2621fb1c.svg";